<template>
  <div class="record-video" v-show="value_self">
    <div class="record-video-mask"></div>
    <div class="page-content">
      <video ref="video" class="video" width="600" height="450" :class="{fullscreen: fullscreen}" :poster="chunkObj.poster" @canplay="videoCanPlay()" @loadedmetadata="videoLoadedmetadata"></video>
      <div class="video-controls" v-show="btn_status < 3">
        <div class="action">
          <span @click="start_record" v-show="btn_status == 0">
            <img src="./images/start.png" alt="">
            <span>录制</span>
          </span>
          <span @click="end_record" v-show="btn_status == 1">
            <img src="./images/stop.png" alt="">
            <span>完成</span>
          </span>
          <span @click="pause_record" v-show="btn_status == 1">
            <img src="./images/pause.png" alt="">
            <span>暂停</span>
          </span>
          <span @click="resume_record" v-show="btn_status == 2">
            <img src="./images/start.png" alt="">
            <span>继续</span>
          </span>
          <div class="status-box">
            <div>{{btn_status_words}}</div>
            <div>{{`${computed_record_time}${maxRecordTime == 'Infinity' ? '' : '/' + computed_maxRecordTime}`}}</div>
          </div>
          <span @click="close">
            <img src="./images/close.png" alt="">
            <span>退出</span>
          </span>
        </div>
      </div>
      <div class="video-play-controls" v-show="btn_status == 3">
        <!-- 播放按钮 -->
        <div class="vcPlayBtn" @click="videoPlay()">
          <img src="./images/video-play.png" alt="" v-show="!vcIsPlay">
          <img src="./images/video-pause.png" alt="" v-show="vcIsPlay">
        </div>
        <!-- 当前时间 -->
        <div class="vcPlayTime">{{vcCurrentTime}}</div>
        <div class="vcProgress">
            <!-- 进度 -->
            <input type="range" min="0" max="100" class="videoProgress" @input="mySlidechange" v-model="vcProgress" :style="styleObj"/>
        </div>
        <!-- 总时长 -->
        <div class="vcPlayTime">{{vcTotalTime}}</div>
        <!-- 重新录制 -->
        <!-- <div class="vcRecordBtn" @click="reset()">重新录制</div> -->
        <button class="vcRecordBtn" @click="reset()">重新录制</button>
        <!-- 上传 -->
        <!-- <div class="vcUploadBtn" @click="uploadFile()">上传</div> -->
        <button class="vcUploadBtn" @click="uploadFile()">上 传</button>
      </div>
    </div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import videoRecorder from './videoRecorder';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maxRecordTime: {
      type: Number,
      default: Infinity
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var defaultPoster = 'https://s.eoffcn.com/pigai/admin/img/202004/DtbXj3qSenM3G7JkOjLMgzdssaWBaPwOdySC5BcU.jpeg';
    return {
      value_self: false,
      // 当前录制时长
      record_time: 0,
      intervalId: null,
      btn_status: 0, // 0: 初始化, 1: 录制中 2: 录制暂停 3:录制完成
      defaultPoster: defaultPoster,
      chunks: [],
      chunkObj: {
        poster: defaultPoster
      },
      recorder: null,
      stream: null,
      // 视频播放状态
      vcIsPlay: false,
      vcCurrentTime: '00:00', //视频当前时间
      vcTotalTime: '', // 视频总时长
      vcProgress: 0 // 进度
    }
  },
  computed: {
    btn_status_words () {
      var words = ['未开始', '录制中', '已暂停', '录制完成'];
      return words[this.btn_status];
    },
    styleObj() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Firefox") > -1) {
        return {};
      }
      return {backgroundSize:+ this.vcProgress*100/100 +'% 100%'};
    },
    computed_record_time () {
      return this.getFormatVideoTime(this.record_time);
    },
    computed_maxRecordTime () {
      return this.getFormatVideoTime(this.maxRecordTime);
    }
  },
  methods: {
    // 初始化
    init (cb) {
      this.record_time = 0;
      this.btn_status = 0;
      this.chunks = [];
      this.chunkObj = {
        poster: this.defaultPoster
      };
      // 最新谷歌浏览器中关闭弹窗会执行绑定事件onstop，所以需要解绑
      this.unBindEvents();
      this.recorder = null;
      if (this.stream) {
        videoRecorder.closeStream(this.stream);
        this.stream = null;
      }
      this.video.srcObject = null;
      this.video.src = '';
      this.video.muted = true;
      this.video.onended = null;
      this.video.ontimeupdate = null;
      this.vcIsPlay = false;
      this.vcCurrentTime = '00:00', //视频当前时间
      this.vcTotalTime = '', // 视频总时长
      this.vcProgress = 0, // 进度
      this.clearInterval();
      cb && cb();
    },
    // 错误处理器
    errorLister (err) {
      this.$emit('errorLister', err);
    },
    // 视频播放或暂停
    videoPlay () {
      if(this.vcIsPlay){
        this.video.pause();
      }else{
        this.video.play();
      }
      if (this.video.onended == null) {
        this.video.onended = this.videoEnded;
      }
      if (this.video.ontimeupdate == null) {
        this.video.ontimeupdate = this.videoTimeUpdate;
      }
      this.vcIsPlay = !this.vcIsPlay;
    },
    // 拖动进度条
    mySlidechange () {
      var duration =this.video.duration;
      this.video.currentTime = duration * this.vcProgress / 100;
    },
    // 重新录制
    reset () {
      this.init(() => {
        this.requestAudioAccess();
      });

    },
    // 上传
    uploadFile () {
      this.$emit('uploadFile', this.chunkObj);
      this.close();
    },
    videoTimeUpdate(){
      if (this.btn_status == 3) {
        var currTime =this.video.currentTime;
        var duration =this.video.duration;
        this.vcCurrentTime = this.getFormatVideoTime(currTime);
        var pre = currTime / duration;
        this.vcProgress = pre*100 || 0;
      }
    },
    videoCanPlay () {
        var duration =this.video.duration;
        this.vcTotalTime = this.getFormatVideoTime(duration);
    },
    videoLoadedmetadata () {
      if (this.btn_status != 3) {
        return;
      }
      const duration = this.video.duration;
      const _this = this;
      if (duration === Infinity) {
          // _this.video.currentTime = 1e101;
          _this.video.ontimeupdate = function () {
              this.ontimeupdate = null;
              // 不重新设置currtTime,会直接触发audio的ended事件，因为之前将currentTime设置成了一个比音频时长还大的值。所以要将currentTime重置为初始状态。
              // 注: 这里有一个问题，直接设置为0 是不起作用的。需要重新设置一下audio.currentTime = 1e101;然后再设置为0
              // _this.video.currentTime = 1e101;
              _this.video.currentTime = 0;
          };
          if (this.maxRecordTime != Infinity) {
              _this.video.currentTime = this.maxRecordTime * 2;
          } else {
              _this.video.currentTime = 3600 * 24 * 30; //足够大了
          }
      }
    },
    videoEnded () {
      this.vcIsPlay = !this.vcIsPlay;
      this.video.currentTime = 0;
      this.vcProgress = 0;
    },
    // 格式化时间
    getFormatVideoTime(time) {
        var time = time;
        var m = parseInt(time/60),
            s = parseInt(time%60);
        m = m < 10 ? "0"+m : m;
        s = s < 10 ? "0"+s : s;
        return m+":"+s;
    },
    close () {
      this.init();
      this.value_self = false;
      this.$emit('update:value', false);
    },
    // 设置定时器
    setInterval () {
      this.intervalId = window.setInterval(() => {
        this.record_time += 1;
        if (this.record_time > this.maxRecordTime) {
          this.end_record();
        }
      }, 1000)
    },
    // 清除定时器
    clearInterval () {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
      }
    },
    start_record () {
      if (!this.recorder) {
        return this.errorLister({title: '权限提示', message: '当前系统需要获取摄像头和麦克风权限，才能正常使用此功能，请在设置中开启'});
      }
      this.video.srcObject = this.stream;
      this.video.muted = true;
      this.video.play();
      this.setInterval();
      this.recorder.start();
      this.btn_status = 1;

    },
    pause_record () {
      this.clearInterval();
      this.recorder.pause();
      this.btn_status = 2;
    },
    resume_record () {
      this.setInterval();
      this.recorder.resume();
      this.btn_status = 1;
    },
    end_record () {
      this.clearInterval();
      this.recorder.stop();
      this.btn_status = 3;
      // 关闭媒体流
      videoRecorder.closeStream(this.stream);
    },
    requestAudioAccess () {
        var constraints = {audio: true, video: true};
        videoRecorder.getUserMedia(constraints, (err, stream) => {
          if (err) {
              console.log(err);
              if (err.name == 'NotFoundError' || err.name == 'DevicesNotFoundError') {
                this.errorLister({title: '录制失败', message: '检测不到设备，请确保您的电脑有摄像头和麦克风且与电脑正确连接'});
              } else if (err.name == 'NotReadableError' || err.name == 'TrackStartError') {
                this.errorLister({title: '录制失败', message: '设备(摄像头或麦克风)已占用，请关闭使用设备的其它标签页并刷新页面'});
              } else if (err.name == 'OverconstrainedError' || err.name == 'ConstraintNotSatisfiedErrror') {
                this.errorLister({title: '录制失败', message: '无法满足录制要求，请使用其它浏览器'});
              } else if (err.name == 'NotAllowedError' || err.name == 'PermissionDeniedError') {
                this.errorLister({title: '权限提示', message: '当前系统需要获取摄像头和麦克风权限，才能正常使用此功能，请在设置中开启'});
              } else if (err.name == 'TypeError') {
                this.errorLister({title: '录制失败', message: 'getUserMedia参数错误，必须至少请求一个音频和视频'});
              } else if (err.name == 'Error') {
                this.errorLister({title: '录制失败', message: err.message || ''});
              } else {
                this.errorLister({title: err.name, message: err.message || ''});
              }
              this.close();
              return;
          }
          if (MediaRecorder) {
              this.recorder = new window.MediaRecorder(stream);
          } else {
              console.error("not support MediaRecorder");
              this.errorLister({title: '录制失败', message: '浏览器不支持MediaRecorder，请使用其它浏览器' || ''});
              this.close();
              return;
          }
          this.stream = stream;
          this.bindEvents();
          if (!this.value_self) {
            this.value_self = true;
          }
      })
    },
    bindEvents () {
        this.recorder.ondataavailable = this.getRecordingData;
        this.recorder.onstop = this.saveRecordingData;
    },
    unBindEvents () {
        this.recorder.ondataavailable = null;
        this.recorder.onstop = null;
    },
    getRecordingData (e) {
        this.chunks.push(e.data);
    },

    saveRecordingData  () {
        let blob = new Blob(this.chunks, { type: 'video/mp4;codecs=h264' }),
        videoStream = URL.createObjectURL(blob);
        // this.chunkObj = {stream: videoStream, blob, ...this.chunkObj};
        this.chunkObj.stream = videoStream;
        this.chunkObj.blob = blob;
        this.onCapture();
        this.chunks = [];
    },
    // 获取视频截图
    onCapture () {
        this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
        this.canvas.toBlob((blob) => {
            let src = URL.createObjectURL(blob);
            this.chunkObj.poster = src;
            this.video.srcObject = null;
            // this.video.poster = this.chunkObj.poster;
            this.video.src = this.chunkObj.stream;
            this.video.muted = false;
        });
    }
  },
  mounted () {
      this.video = this.$refs.video;
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext('2d');
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue) {
        this.requestAudioAccess();
      } else {
        this.value_self = false;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.record-video {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  z-index: 9999;
}
.record-video .record-video-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
}
.record-video .page-content {
  width: fit-content;
  height: fit-content;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
}
.record-video .page-content .video {
  object-fit:fill;
}
.fullscreen{
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
}
.record-video .page-content .video-controls {
  width: 100%;
  height: 50px;
  padding: 3px 0;
  box-sizing: border-box;
  position: absolute;
  bottom: 6px;

}
.record-video .page-content .video-controls .action {
  width: fit-content;
  height: 44px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.record-video .page-content .video-controls .action span {
  /* display: inline-block; */
  height: fit-content;
  display: flex;
  align-items: center;
  margin: 0 5px;
  cursor: pointer;
}
.record-video .page-content .video-controls .action img {
  width: 20px;
  height: auto;
}
.record-video .page-content .video-controls .action .status-box {
  width: 80px;
  height: 40px;
  border: 1px solid #000;
  border-radius: 4px;
  font-size: 12px;
  margin: 0 10px;
  padding: 3px 5px 0;
  box-sizing: border-box;
}
.record-video .page-content .video-controls .action .status-box div {
  width: 100px;
  /* height: 40px;
  border: 1px solid #000;
  border-radius: 4px; */
}
.record-video .page-content .video-play-controls {
  width: 100%;
  height: 50px;
  padding: 3px 0;
  box-sizing: border-box;
  position: absolute;
  bottom: 6px;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;
}
.record-video .page-content .video-play-controls .vcPlayBtn {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}
.record-video .page-content .video-play-controls .vcPlayBtn img {
  width: 100%;
  height: 100%;
}
.record-video .page-content .video-play-controls .vcPlayTime {
  margin: 0 10px;
  width: 40px;
}
.record-video .page-content .video-play-controls .vcProgress {
  flex: 1 1 auto;
}
.record-video canvas {
  display: none;
}
input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    border-radius: 10px; /*这个属性设置使填充进度条时的图形为圆角*/
    background-image: linear-gradient(#059CFA, #059CFA);
    background-repeat: no-repeat;
    background-color: #fff;
    background-size: 0% 100%;
}
input[type=range]::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 4px; /*将轨道设为圆角的*/
    /*轨道内置阴影效果*/
    /* box-shadow: 0 1px 1px #def3f8, inset 0 .125em .125em #0d1112;  */
}
input[type=range]:focus {
    outline: none;
}
input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    margin-top: -2px; /*使滑块超出轨道部分的偏移量相等*/
    background: #ffffff;
    border-radius: 50%; /*外观设置为圆形*/
    border: solid 0.125em rgba(205, 224, 230, 0.5); /*设置边框*/
    box-shadow: 0 .125em .125em #3b4547; /*添加底部阴影*/
}
/*兼容Firefox浏览器*/
input[type=range]::-moz-range-track {
  height: 8px;
  border-radius: 4px; /*将轨道设为圆角的*/
  /*轨道内置阴影效果*/
  background-color: #fff;
  /* box-shadow: 0 1px 1px #def3f8, inset 0 .125em .125em #0d1112;  */
}
input[type=range]::-moz-range-progress {
    background: linear-gradient(#059CFA, #059CFA);
    height: 100%;
    border-radius: 10px;
}
input[type=range]::-moz-range-thumb {
  -moz-appearance: none;
  height: 12px;
  width: 12px;
  margin-top: -2px; /*使滑块超出轨道部分的偏移量相等*/
  background: #fff;
  border-radius: 50%; /*外观设置为圆形*/
  border: solid 0.125em rgba(205, 224, 230, 0.5); /*设置边框*/
  box-shadow: 0 .125em .125em #3b4547; /*添加底部阴影*/
}
.record-video .page-content .video-play-controls .vcRecordBtn {
  background-color: #fff;
  color: #000;
  padding: 3px 8px;
  border-radius: 4px;
  border-color: #fff;
  cursor: pointer;
  outline: none;
  margin-left: 10px;
  border-width: 1px;
  font-size: 12px;
}
.record-video .page-content .video-play-controls .vcUploadBtn {
  background-color: #409EFF;
  color: #fff;
  padding: 3px 10px;
  border-radius: 4px;
  border-color: #409EFF;
  cursor: pointer;
  outline: none;
  margin: 0 10px;
  border-width: 1px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/record-video/index.vue